'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteProduct = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * deleteProduct
 * 
 * Deletes a product.
 * @param {string} feis_id 
 * @param {string} product_id
 */
var deleteProduct = exports.deleteProduct = function deleteProduct(feis_id, product_id) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      feis_id: feis_id,
      product_id: product_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/products/' + product_id,
        method: 'DELETE'
      },
      types: ['DELETE_PRODUCT_START', 'DELETE_PRODUCT', 'DELETE_PRODUCT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/deleteProduct.js
// module id = 660
// module chunks = 0